import { capturePasswordRecoveryFromUrl } from './lib/passwordRecovery';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initSentry } from './lib/sentry';

// Imported first so module init records type=recovery before the Supabase client
// (loaded through App) consumes the URL hash. This call covers a still-present hash.
capturePasswordRecoveryFromUrl();

// Initialize Sentry as early as possible
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
